import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { prefixErrorText } from 'utils/react-hook-form'

interface ListItem {
  value:string
}

interface MyAcknowledgeProps {
  variableInputName: string;
  acknowledgements: ListItem[];
  heading?: string;
  label: string;
  errorMessageString: string;
  ariaLabel?: string;
  addErrorPrefix?: boolean;
}

export const MyAcknowledge: React.FC<MyAcknowledgeProps> = ({
  addErrorPrefix, // TODO - set this to true by default once MCF prod has this in
  variableInputName,
  acknowledgements,
  heading,
  label,
  errorMessageString,
  ariaLabel
}) => {
  const { formState, control } = useFormContext()
  const { errors } = formState
  return (
    <div className='ds-c-fieldset' aria-invalid={!!errors[variableInputName]} tabIndex={-1} id={variableInputName}>
      {heading && <div className='ds-c-heading'><h3 className='ds-text-heading--xl ds-u-margin-bottom--1'>{heading}</h3></div>}
      <div className='ds-u-margin-bottom--6 my-u-border-box '>
        <Controller
          rules={{ required: { value: true, message: errorMessageString } }}
          key={`${variableInputName}`}
          render={({ field, fieldState }) => {
            return (
              <div>
                <div className='ds-c-choice-wrapper'>
                  <input
                    ref={field.ref}
                    className={`ds-c-choice ${fieldState?.error?.message ? 'ds-c-choice--error' : ''}`}
                    id={`checkbox-${variableInputName}`}
                    aria-label={ariaLabel}
                    aria-describedby={fieldState.error ? `error-acknowledgeCheckbox` : undefined}
                    type='checkbox'
                    name={variableInputName}
                    value={field.value}
                    checked={field.value}
                    onChange={field.onChange as any}
                    onBlur={field.onBlur as any}
                  />
                  <label className='my-u-mt--0 ' htmlFor={`checkbox-${variableInputName}`}>
                    <span>{label}</span>
                  </label>
                </div>
                <ul key={`${field.name}`}>
                  {acknowledgements.map((item, index) => {
                    return (
                      <li key={index} className='ds-u-margin-bottom--1 ds-u-padding-left--1 ds-u-margin-left--3 ds-u-font-size--sm'>{item.value}</li>
                    )
                  })}
                </ul>
              </div>
            )
          }}
          name={`${variableInputName}`}
          control={control}
        />
        {errors[variableInputName] &&
          <span className='ds-c-field__error-message' id='error-acknowledgeCheckbox'>
            {addErrorPrefix ? prefixErrorText(errors[variableInputName]?.message) : errors[variableInputName]?.message}
          </span>}
      </div>
    </div>
  )
}
